const Url = {
  /**
   * Return the base domain name, which is composed by
   * the domain name and top level domain (TLD)
   */
  getBaseDomain: (hostname?: string): string => {
    const host = hostname ?? location.hostname;
    return host.split('.').slice(-2).join('.');
  }
};

export {Url};
